module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/1@2x_72b56cc77567723be9c23c94b4a7e6d2.png";